import actions from '../actions/stock';

export const getFilterStockTracking = async (queryString) => {
  return actions.getFilterStockTracking(queryString);
};

export const getFilterStockTransaction = async (queryString) => {
  return actions.getFilterStockTransaction(queryString);
};
export const getAllStockTransactionForCsv = async (queryString) => {
  return actions.getAllStockTransactionForCsv(queryString);
};
export const getAllStockInventoryForCsv = async (queryString) => {
  return actions.getAllStockInventoryForCsv(queryString);
};
